import { Inject, Input, forwardRef, Component } from "@angular/core";
import { DataTableComponent } from "../datatable.component";
import { Column } from "primeng/primeng";

@Component({
  selector: "[pColumnHeaders]",
  templateUrl: "./columnheader.component.html"
})
export class ColumnHeadersComponent {
  constructor(
    @Inject(forwardRef(() => DataTableComponent)) public dt: DataTableComponent
  ) {}

  @Input("pColumnHeaders") columns: Column[];
}
